import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddNew = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8.50586C4 8.22972 4.22386 8.00586 4.5 8.00586H7.5V5.00586C7.5 4.72972 7.72386 4.50586 8 4.50586C8.27614 4.50586 8.5 4.72972 8.5 5.00586V8.00586H11.5C11.7761 8.00586 12 8.22972 12 8.50586C12 8.782 11.7761 9.00586 11.5 9.00586H8.5V12.0059C8.5 12.282 8.27614 12.5059 8 12.5059C7.72386 12.5059 7.5 12.282 7.5 12.0059V9.00586H4.5C4.22386 9.00586 4 8.782 4 8.50586Z",
			fill: "#212121"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 16.5059C12.4183 16.5059 16 12.9241 16 8.50586C16 4.08758 12.4183 0.505859 8 0.505859C3.58172 0.505859 0 4.08758 0 8.50586C0 12.9241 3.58172 16.5059 8 16.5059ZM8 15.5059C4.13401 15.5059 1 12.3719 1 8.50586C1 4.63987 4.13401 1.50586 8 1.50586C11.866 1.50586 15 4.63987 15 8.50586C15 12.3719 11.866 15.5059 8 15.5059Z",
			fill: "#212121"
		})
	]
});
const ForwardRef = forwardRef(SvgAddNew);
export default ForwardRef;
